import React from 'react';
import { Buffer } from 'buffer';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from 'sonner';
import App from './App';
import { ErrorReportPanel } from '@/components/ErrorReportPanel';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { captureHubSpotUserFromUrl } from '@/lib/hubspotUser';
import { loadMarkerWidget } from '@/lib/marker';
import './index.css';

(window as any).Buffer = Buffer;

// De CRM-card geeft de ingelogde HubSpot-gebruiker mee in de URL. Meteen bij het
// opstarten vastleggen, want de query-parameters overleven het navigeren niet.
captureHubSpotUserFromUrl();

loadMarkerWidget();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <TooltipProvider>
        <App />
        <Toaster richColors position="bottom-center" />
        <ErrorReportPanel />
        <ConfirmDialog />
      </TooltipProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
